import { v2 } from '@saucelabs/sl-module-builds';

import { NAMESPACE } from './types';

const actions = v2.common.actions.createVDCActions(NAMESPACE);
export default actions;
